module.exports = __webpack_public_path__ + "media/images/icons/plus-44139eb0c96a3b44325caeac7ade8234.svg";